module.exports = __webpack_public_path__ + "img/2.b7c82ab7.jpg";